import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { asyncScheduler, EMPTY as empty, Observable, of, observable } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import {
  GetUsers,
  GetUsersSuccess,
  GetUsersFailure,
  UsersActionTypes,
  UpdateUser,
  UpdateUserSuccess,
  UpdateUserFailure,
  AddUser,
  AddUserSuccess,
  AddUserFailure,
  DeleteUser,
  DeleteUserSuccess,
  DeleteUserFailure,

} from '../actions/users.actions';
import { UsersService } from '../../users.service';
import { User } from '../../user';
import { ToastService } from '../../../toast/toast.service';

@Injectable()
export class UsersEffects {
  
  getUsers$ = createEffect(() =>
  this.actions$.pipe(
    ofType<GetUsers>(UsersActionTypes.GetUsers),
    switchMap(() => {
      return this.usersService.getUsers().pipe(
        switchMap(users => {
          return of(new GetUsersSuccess(users));
        }),
        catchError(error => of(new GetUsersFailure(error)))
      );
    })
  )
  );

  
  updateUser$ = createEffect(() =>
  this.actions$.pipe(
    ofType<UpdateUser>(UsersActionTypes.UpdateUser),
    map(action => action.payload),
    switchMap(user => {
      return this.usersService.updateUser(user).pipe(
        switchMap((updatedUser: User) => {
          this.toastService.addMessage({ text: `User "${updatedUser.firstName} ${updatedUser.lastName}" was successfully updated.`, error: false });
          return of(new UpdateUserSuccess(updatedUser));
        }),
        catchError(error => {
          this.toastService.addMessage({ text: `An error occured while updating user "${user.firstName} ${user.lastName}". Save Failed.`, error: true });
          return of(new UpdateUserFailure(error));
        })
      );
    })
  )
  );

  
  addUser$ = createEffect(() =>
  this.actions$.pipe(
    ofType<AddUser>(UsersActionTypes.AddUser),
    map(action => action.payload),
    switchMap(user => {
      return this.usersService.addUser(user).pipe(
        switchMap((newUser: User) => {
          this.toastService.addMessage({ text: `User "${newUser.firstName} ${newUser.lastName}" was successfully added.`, error: false });
          return of(new AddUserSuccess(newUser));
        }),
        catchError(error => {
          this.toastService.addMessage({ text: `An error occured while adding user "${user.firstName} ${user.lastName}". Save Failed.`, error: true });
          return of(new AddUserFailure(error));
        })
      );
    })
  )
  );

  
  DeleteUser$ = createEffect(() =>
  this.actions$.pipe(
    ofType<DeleteUser>(UsersActionTypes.DeleteUser),
    map(action => action.payload),
    switchMap(id => {
      return this.usersService.deactivateUser(id).pipe(
        switchMap((user: User) => {
          this.toastService.addMessage({ text: `User was successfully deactivated.`, error: false });
          return of(new DeleteUserSuccess(user));
        }),
        catchError(error => {
          this.toastService.addMessage({ text: `An error occured while deactivating user. Save Failed.`, error: true });
          return of(new DeleteUserFailure(error));
        })
      );
    })
  )
  );

  constructor(private actions$: Actions, private usersService: UsersService, public toastService: ToastService) {}
}
